import postApiData from 'utils/api/postApiData';
import { ENDPOINT } from 'constants/api';
import { AUTH_VERIFY_EMAIL } from '../../constants/pathNames';

const sendEmail = (email: string): Promise<unknown> => postApiData(
  `${ENDPOINT.AUTH_EMAIl_SEND}`,
  {
    email,
    redirect_url_base: `${window.location.origin}${AUTH_VERIFY_EMAIL}`,
  },
);

const verifyEmail = (email: string, hash: string): Promise<unknown> => postApiData(
  `${ENDPOINT.AUTH_EMAIL_VERIFY}`,
  {
    email,
    verification: hash,
  },
);

export {
  sendEmail,
  verifyEmail,
};
